import type { DrawingProps } from "./types";

/** The cast's lead. A pencil with a face, tilted, mid stroke. */
export function Pencil({ size = 64, className, title }: DrawingProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <g transform="rotate(-24 32 32)">
        <path
          d="M23 8h18a4 4 0 0 1 4 4v27H19V12a4 4 0 0 1 4-4Z"
          fill="var(--marigold)"
          stroke="var(--ink)"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
        <path d="M19 39h26l-13 15L19 39Z" fill="var(--sage-tint)" stroke="var(--ink)" strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M28 47h8l-4 5-4-5Z" fill="var(--ink)" />
        <path d="M19 16h26" stroke="var(--ink)" strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="27" cy="26" r="2.2" fill="var(--ink)" />
        <circle cx="37" cy="26" r="2.2" fill="var(--ink)" />
        <path d="M27 31c1.8 2.4 8.2 2.4 10 0" stroke="var(--ink)" strokeWidth="2.5" strokeLinecap="round" />
      </g>
    </svg>
  );
}
